import { useState } from "react";
import { Stack, Button, Divider, Box, Tooltip, IconButton, CircularProgress } from "@mui/material";
import { Edit as EditIcon, } from '@mui/icons-material';
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import HistoryIcon from "@mui/icons-material/History";
import SendIcon from "@mui/icons-material/Send";
import { enqueueSnackbar } from 'notistack';
import { PermissionWrapper } from "../../../wrappers";
import { getGlobalCookie, checkApiStatus } from "../../../utils";
import AssignUserModal from "./AssignUserModal";
import StatusChangeModal from "./StatusChangeModal";
import TimelineModal from "./TimelineModal";
import ApproverModal from "./ApproverModal";
import VerifyAmountModal from "./VerifyAmountModal";
import { useParams } from "react-router";
import { trackActivity } from "../../../utils/mixpanel";
import { globalPutService } from '../../../utils/globalApiServices';
import { updateClaimApi } from '../apiServices';
import StatusButton from "./StatusButton";

const ApprovalHeader = ({ shopVisit, isLoading, claimListLoader, getClaimList, claimData, onEdit, fileUpload, onTabChange, onProceedSuccess }) => {
    const params = useParams()
    const userInfo = JSON.parse(getGlobalCookie('lessorAccess'))
    const checkClaimApproverLegacy = claimData?.approver_users?.some(ele => ele.id === userInfo?.user?.id)
    const checkClaimApprover = checkClaimApproverLegacy || claimData?.round_approver_users?.includes(userInfo?.user?.id)
    const isFullyApproved = !!claimData?.is_approved_group
    const hasNoApproversLegacy = claimData?.approver_users == null || claimData.approver_users.length === 0
    const hasNoApprovers = hasNoApproversLegacy
        && (claimData?.round_approver_users == null || claimData.round_approver_users.length === 0)
    const [modalData, setModalData] = useState({ approverModal: false, assignUserModal: false, statusModal: false, searchUser: "", editModal: false })
    const [timeLineData, setTimeLineData] = useState({ modal: false, data: [] })
    const [verifyAmount, setVerifyAmount] = useState({ modal: false })
    const [proceedLoading, setProceedLoading] = useState(false)
    const [approvedActionDone, setApprovedActionDone] = useState(false)
    const showEditIcon = claimData?.status?.value === 1
        || (claimData?.status?.value === 2 && (hasNoApproversLegacy || checkClaimApproverLegacy))
        || (claimData?.status?.value === 3 && isFullyApproved && claimData?.payout_status?.value !== 6 && !approvedActionDone && checkClaimApprover)
    const onSearchUserField = (event) => { setModalData({ ...modalData, searchUser: event.target.value }); };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Shop Visit Claim`, page_type: page_type, })
    }
    const onApprovedActionSuccess = () => { getClaimList("pageLoader"); setApprovedActionDone(true); onProceedSuccess && onProceedSuccess(); }
    const handleProceedForClaim = () => {
            setVerifyAmount({ modal: true }); handleItemClicked('Proceed For Claim Button')
    
    }
    return (
        <>
            <Stack direction="row" spacing={1} alignItems="center">
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['U'] }}>
                    {showEditIcon ? <IconButton sx={{ p: 0 }} onClick={() => { onEdit(); handleItemClicked('EditIcon') }}> <Tooltip title="Edit">
                        <EditIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                    </Tooltip></IconButton> : null}
                </PermissionWrapper>
                {showEditIcon && claimData?.approver_users?.length > 0 ? <Divider orientation="vertical" flexItem /> : null}
                {claimData?.approver_users?.length > 0 && <Button
                    variant="outlined"
                    size="small"
                    startIcon={<GroupOutlinedIcon />}
                    sx={{ textTransform: "none", cursor: "pointer" }}
                    onClick={() => { setModalData({ ...modalData, approverModal: true, data: claimData }); handleItemClicked('Users Icon') }}
                >
                    Users
                </Button>}
                {(claimData?.status?.value === 1  ||claimData?.approver_users?.length > 0) ? <Divider orientation="vertical" flexItem /> :null}
                <Button
                    variant="outlined"
                    size="small"
                    startIcon={<HistoryIcon />}
                    sx={{ textTransform: "none" }}
                    onClick={() => { setTimeLineData({ modal: true, data: claimData }); handleItemClicked('RevisionHistoryIcon') }}
                >
                    Status Timeline
                </Button>
                <Divider orientation="vertical" flexItem />
                {claimData?.status && (
                    <StatusButton statusData={claimData?.payout_status?.value === 6 ? { value: 8, label: "Paid" } : claimData?.status} />
                )}
            </Stack>

            <Stack direction="row" spacing={1}>
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['APR_REJ'] }}>
                    {(hasNoApproversLegacy || checkClaimApproverLegacy
                    ) && claimData?.status?.value === 2 ?
                        <Button
                            color="primary"
                            variant="outlined"
                            size="small"
                            onClick={() => { setModalData({ ...modalData, statusModal: true, data: claimData }); handleItemClicked('Approve/Reject Button') }}
                        >
                            Approve/Reject
                        </Button> : null}
                </PermissionWrapper>
                {claimData?.status?.value === 3 && isFullyApproved && claimData?.payout_status?.value !== 6 && checkClaimApprover && !claimListLoader?.pageLoader ? (
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['U'] }}>
                        <Button
                            color="primary"
                            variant="contained"
                            size="small"
                            disabled={proceedLoading}
                            onClick={() => { handleProceedForClaim() }}
                            sx={{ textTransform: "none", fontSize: { xs: "7px", md: '13px' } }}
                        >
                            {proceedLoading ? <CircularProgress color='inherit' size={16} /> : "Proceed For Claim"}
                        </Button>
                    </PermissionWrapper>
                ) : null}
                {claimData?.status?.value === 3 && isFullyApproved && claimData?.payout_status?.value !== 6 && checkClaimApprover && !claimListLoader?.pageLoader ? <Divider orientation="vertical" flexItem /> : null}
                <Box style={{ display: 'flex', alignItems: "center", }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['U'] }}>
                        {/* Add Reviewer functionality (status === 2) disabled for Claim */}
                        {shopVisit?.status &&
                            (claimData?.status?.value === 1 || (claimData?.status?.value === 3 && isFullyApproved && claimData?.payout_status?.value !== 6)) &&
                            !(claimData?.status?.value === 3 && approvedActionDone) &&
                            (hasNoApprovers || checkClaimApprover) ?
                            <>
                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['APR_REJ'] }}>
                                    {(claimData?.status?.value === 2) ? <Box className="divider"></Box> : null}
                                </PermissionWrapper>
                                <Box sx={{ display: 'flex', alignItems: "center", }}>
                                    <Box >
                                        <Button
                                            color="primary"
                                            variant={claimData?.status?.value === 3 ? "outlined" : "contained"}
                                            size="small"
                                            onClick={() => { setModalData({ ...modalData, assignUserModal: true, data: claimData }); handleItemClicked('Send for Review Button') }}
                                            startIcon={<SendIcon />}
                                            sx={{
                                                textTransform: "none",
                                                fontSize: { xs: "7px", md: '13px' }
                                            }}
                                        >
                                            {[1, 3].includes(claimData?.status?.value) ? "Send for Review" : "Add Reviewer"}
                                        </Button>
                                    </Box>
                                </Box>
                            </> : null}
                    </PermissionWrapper>
                </Box>
            </Stack>
            {modalData?.assignUserModal ? <AssignUserModal params={params} modalData={modalData} onSearchUserField={onSearchUserField} pageTitle="Claim" pageLoader={isLoading?.pageLoader} userData={modalData?.data} getResponseBack={() => claimData?.status?.value === 3 ? onApprovedActionSuccess() : getClaimList("pageLoader")} toggleModalFn={() => setModalData({ assignUserModal: false, searchUser: "" })} /> : null}
            {verifyAmount?.modal ? <VerifyAmountModal shopVisit={shopVisit} claim={claimData} verifyAmount={verifyAmount} onTabChange={onTabChange} getResponseBack={onApprovedActionSuccess} onToggleModal={() => setVerifyAmount({ modal: false })} /> : null}
            {modalData?.statusModal ? <StatusChangeModal params={params} modalData={modalData} pageTitle="Claim" pageLoader={isLoading?.pageLoader} shopVisit={shopVisit} getResponseBack={() => getClaimList("pageLoader")} toggleModalFn={() => setModalData({ statusModal: false, searchUser: "" })} fileUpload={fileUpload} /> : null}
            {modalData?.approverModal ? <ApproverModal modalData={modalData} onSearchUserField={onSearchUserField} pageTitle="Claim" pageLoader={isLoading?.pageLoader} approvalData={modalData?.data?.approver_users} remarks={modalData?.data?.remarks} toggleModalFn={() => setModalData({ approverModal: false, searchUser: "" })} /> : null}
            {timeLineData?.modal ? <TimelineModal params={params} pageTitle="Claim" slug={timeLineData?.data?.slug} timeLineData={timeLineData} toggleModalFn={() => setTimeLineData({ modal: false })} /> : null}
        </>

    );
};

export default ApprovalHeader;